import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { ShellRoutes } from '../portal-routes';

/**
 * The callback route only completes an Okta sign-in. Opened without the Okta response (bookmark, typed URL)
 * the SDK has nothing to do and the page would stay blank, so the landing route decides instead.
 */
export const loginRedirectGuard: CanActivateFn = () =>
  inject(OKTA_AUTH).isLoginRedirect() || inject(Router).parseUrl(ShellRoutes.landing);
